(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();
  ready(() => {
    document.body.classList.add('etsy-preview-page');
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex,follow';
    document.head.appendChild(robots);
    const customizer = document.querySelector('etsy-circle-monogram-customizer');
    const download = document.querySelector('[data-download-preview]');
    const returnButton = document.querySelector('[data-return-etsy]');
    if (!customizer || !download) return;

    const saveBlob = (blob, initials) => {
      if (!blob) throw new Error('The preview image could not be generated.');
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `honest-ice-circle-monogram-${initials || 'preview'}.png`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1200);
    };

    download.addEventListener('click', async () => {
      const input = customizer.querySelector('.circle-monogram__input');
      const error = customizer.querySelector('.ice-customizer__error');
      const canvas = customizer.querySelector('canvas');
      const initials = (input?.value || '').trim().toUpperCase();
      if (!canvas || initials.length !== 3) {
        if (error) { error.hidden = false; error.textContent = 'Enter exactly three initials before downloading the preview.'; }
        input?.focus();
        return;
      }
      download.disabled = true;
      download.innerHTML = '<span>•</span> Preparing image…';
      try {
        customizer.querySelector('[data-ice-view="top"]')?.click();
        await new Promise(resolve => setTimeout(resolve, 180));
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
        saveBlob(blob, initials);
        if (error) { error.textContent = ''; error.hidden = true; }
      } catch (err) {
        if (error) { error.hidden = false; error.textContent = err.message || 'The preview image could not be downloaded.'; }
      } finally {
        download.disabled = false;
        download.innerHTML = '<span>↓</span> Download preview image';
      }
    });

    returnButton?.addEventListener('click', () => {
      location.href = 'https://honestice.etsy.com/listing/1826523750/monogram-ice-trays-custom-mold-for';
    });
  });
})();
